import { useDispatch } from 'react-redux'
import { extractErrorMessage } from '../../../../_config'
import { useAppLoader } from './appLoaderHook'

export function useApiCall() {

  const dispatch = useDispatch()
  const { showLoader, hideLoader } = useAppLoader()

  const callApi = (sagaAction: string, dataOrParams: unknown = {}, callbackSuccess: (message: string, resp: unknown) => void, callbackError: (message: string, resp: unknown) => void, isLoader: boolean = true) => {
    if (isLoader) showLoader()
    dispatch({
      type: sagaAction,
      payload: dataOrParams,
      callbackSuccess: (data: unknown) => {
        const dataObj = data && typeof data === 'object' ? (data as Record<string, unknown>) : {}
        const message = dataObj.message ? String(dataObj.message) : 'Request processed successfully'
        const resp = dataObj.data ?? null
        if (isLoader) hideLoader()
        if (callbackSuccess) {
          callbackSuccess(message, resp)
        }
      },
      callbackError: (error: unknown) => {
        const errorObj = error && typeof error === 'object' ? (error as Record<string, unknown>) : {}
        const errorData = errorObj.data && typeof errorObj.data === 'object' ? (errorObj.data as Record<string, unknown>) : undefined
        const message = extractErrorMessage(
          errorData && (errorData as { errors?: unknown }).errors ? errorObj : (errorObj.message ? errorObj.message : null),
          'Unable to process request, please try again'
        )
        const resp = errorData ?? null
        if (isLoader) hideLoader()
        // callbackError && callbackError({
        //   message: message,
        //   resp: resp
        // })
        if (callbackError) {
          callbackError(message, resp)
        }
      }
    })
  }
  return callApi
}